export const AccountType_User = 'user';
export const AccountType_Service = 'service';
export const _accountTypes = ['user', 'service'];
export const accountTypes = [..._accountTypes];
export const Account_DbKey = 'user-account--accounts';
//# sourceMappingURL=types.js.map